import moment from "moment";
import SessionMixin from "@/components/shared/mixins/sessionMixin";
import StrategyManager from "@/strategies/manager";
import { ReservationService } from "smck-service";
import { mapActions, mapState } from "vuex";
import Vue from "vue";
import { zValidationGuestModal } from "zoox-components";
import {
  ApiClient,
  CustomHeadersService,
  FlashMessageService
} from "zoox-infra";

export default {
  name: "MultReservation",
  mixins: [SessionMixin],
  data() {
    return {
      selectedPersonId: null,
      selectedGuestId: null,
      selectedReservation: null,
      showRule: true,
      reservationService: new ReservationService(Vue),
      apiClient: new ApiClient(Vue),
      guestComunicationOptions: null,
      validationModalStep: 0,
      validationCode: null,
      showValidationModal: false,
      radioGroupSelectValidationModel: null,
      radioGroupSelectValidationLabels: [
        this.$t("PIN.SEND_MAIL"),
        this.$t("PIN.SEND_SMS")
      ]
    };
  },
  components: {
    "z-validation-guest-modal": zValidationGuestModal
  },
  computed: {
    ...mapState(["currentPersonId", "isQualifiedGuest", "loading"]),
    reservationsToShow: function() {
      let hasReservationToShow = false;
      let reservations = this.reservations.map(i => {
        const item = i;
        item.checked = false;
        item.show = this.showCheckinButton(item);
        // se houver pelo menos uma reserva oculta, mostrar botao de exibir anteriores
        if (!item.show) {
          this.hasPreviousReservations = true;
        } else {
          hasReservationToShow = true;
        }

        return item;
      });
      if (reservations.length > 0 && hasReservationToShow) {
        return reservations;
      } else {
        this.$redirectSearch();
      }
    }
  },
  mounted() {
    if (this.loading === -1) {
      const strategyManager = new StrategyManager();

      strategyManager.startLoading();
    }

    Vue.$globalEvent.$on("languageChanged", () => {
      this.radioGroupSelectValidationLabels = [
        this.$t("PIN.SEND_MAIL"),
        this.$t("PIN.SEND_SMS")
      ];
    });
  },
  methods: {
    ...mapActions([
      "$setCurrentReservation",
      "$setIsQualifiedGuest",
      "$setAuthenticatedPersonGuestId",
      "$setCurrentPersonId",
      "$setIsSamePersonFromRecon"
    ]),
    async setReservation(res, guestId) {
      this.selectedGuestId = guestId;
      this.selectedReservation = res;

      const reservationWithOrder = await this.reservationService.getById({
        reservationId: res.id
      });
      delete reservationWithOrder.links;

      const personIdFromSelectedGuest = await this.reservationService.getPersonId(
        res.id,
        guestId
      );

      this.selectedPersonIdFromContactInfo = personIdFromSelectedGuest.personId;

      const personIdExists =
        this.selectedPersonIdFromContactInfo != null &&
        this.selectedPersonIdFromContactInfo !== "Person not found.";

      const currentPersonIdExists = this.currentPersonId != null;
      if (
        currentPersonIdExists &&
        !this.isQualifiedGuest &&
        personIdExists &&
        this.currentPersonId === this.selectedPersonIdFromContactInfo
      ) {
        this.$setCurrentPersonId(null);
        this.$setIsSamePersonFromRecon(true);

        this.reservationService.setLocalReservation(reservationWithOrder);
        this.$setCurrentReservation(reservationWithOrder);
        this.goToFillFnrh(reservationWithOrder, guestId);
      } else {
        if (!personIdExists) {
          this.$setIsSamePersonFromRecon(false);
          this.goToFillFnrh(reservationWithOrder, guestId);
        } else {
          if (!currentPersonIdExists) {
            this.$setIsSamePersonFromRecon(false);
            this.$setCurrentReservation(reservationWithOrder);
            this.$handleMultipleGuests(reservationWithOrder, true, false);
          }

          if (personIdFromSelectedGuest.personId === this.currentPersonId) {
            this.$setIsSamePersonFromRecon(true);
            this.goToFillFnrh(reservationWithOrder, guestId);
          } else {
            this.$setCurrentReservation(reservationWithOrder);
            this.$setIsSamePersonFromRecon(false);
            this.guestComunicationOptions = this.guestComunicationOptions = (
              await this.reservationService.getPersonId(
                reservationWithOrder.id,
                guestId
              )
            ).contactInfoList;
            this.showValidationModal = true;
          }
        }
      }
    },
    goToFillFnrh(reservation, guestId) {
      this.$router.push(`/guest/${reservation.id}/${guestId}`);
    },
    goToFillFnrhWithoutRecognition() {
      this.closeValidationModal();
      this.$setReservations(this.lastReservations);
      this.$setCurrentPersonId(null);
      this.$setIsQualifiedGuest(false);
      this.$setIsSamePersonFromRecon(false);
      this.goToFillFnrh(this.selectedReservation, this.selectedGuestId);
    },
    async resendCode(value) {
      return this.sendCode(value);
    },
    async sendCode(value) {
      this.validationModalStep = 0;
      if (value) {
        if (value.type === "email") {
          localStorage.setItem("contactId", value.id);
          return this.apiClient
            .post(`v2/portal/send-code`, {
              contactId: value.id,
              reservationNumber: this.selectedReservation.reservationNumber
            })
            .then(resp => {
              if (resp.ok) {
                this.validationModalStep = 2;
              }
            });
        } else {
          return this.apiClient
            .post(`portal/send-code`, {
              contactId: value.id
            })
            .then(resp => {
              if (resp.ok) {
                this.validationModalStep = 2;
              }
            });
        }
      }
    },
    closeValidationModal() {
      this.showValidationModal = false;
      this.guestComunicationOptions = null;
      this.validationModalStep = 0;
      this.validationCode = null;
    },
    checkValidationCode(value) {
      if (value.code && value.code.length === 5) {
        return this.apiClient
          .post(
            `portal/verify-code`,
            {
              contactId: value.contactId,
              verificationCode: value.code
            },
            null,
            false,
            true
          )
          .then(resp => {
            if (resp.token) {
              this.showValidationModal = false;
              this.alreadyAuthenticated = true;

              CustomHeadersService.setCustomHeaders({
                Authorization: resp.token
              });

              const validated = {
                personId: resp.personId,
                validated: resp.validated
              };
              this.$setCurrentPersonId(resp.personId);
              this.$setIsQualifiedGuest(true);
              this.$setIsSamePersonFromRecon(false);
              this.reservationService.setValidatedInfo(validated);

              this.reservationService.setLocalReservation(
                this.selectedReservation
              );

              const res = this.reservationService.updateLocalGuest(
                this.selectedGuestId,
                validated
              );

              this.$setCurrentReservation(this.selectedReservation);
              this.goToFillFnrh(res, this.selectedGuestId);
            }
          })
          .catch(error => {
            if (error.status === 401) {
              FlashMessageService.error(this.$t("NOVO_FLUXO.INCORRECT_PIN"));
            } else {
              FlashMessageService.error(this.$t("NOVO_FLUXO.UNKNOW_ERROR_PIN"));
            }
          });
      }
    },
    showCheckinButton: function(reservation) {
      const guestsNotFinalized = reservation.guests.filter(item => {
        return !item.fnrhId;
      });

      if (
        !guestsNotFinalized ||
        (guestsNotFinalized && guestsNotFinalized.length === 0)
      ) {
        return false;
      }

      if (
        moment
          .utc(reservation.checkinDate)
          .startOf("day")
          .toDate()
          .getTime() >=
        moment
          .utc()
          .subtract(5, "days")
          .startOf("day")
          .toDate()
          .getTime()
      ) {
        return true;
      }

      return false;
    },
    selectGuest: function(reservationId, guestId) {
      this.$redirectGuestView(reservationId, guestId);
    },
    search: function() {
      this.$redirectSearch();
    },
    async redirectTo(reservation, guest, strategy) {
      const strategyManager = new StrategyManager();
      await strategyManager.setStrategy(strategy);
      await strategyManager.redirect(reservation, guest);
    },
    async redirectResume(guest) {
      const company = localStorage.getItem("currentCompany");
      const companyParams = JSON.parse(company).parameters_sc.operation_flow;
      const enableRedirect = companyParams && companyParams.enableRedirect;
      const reservationToShow = this.reservationsToShow.find(res => res.show);

      if (enableRedirect) {
        await this.redirectTo(
          reservationToShow,
          guest,
          companyParams.redirectTo
        );
      } else {
        this.$router.push({ path: `/resume/${guest.fnrhId}` });
      }
    }
  }
};
